export const HEADER_TEXT = 'Mockflix';
export const BACK_TO_SEARCH = 'Back to search';
